<template>
  <Heading
    v-if="data.title !== undefined"
    :title="data.title"
    :level="data.level.value"
    class="title"
  />
</template>

<script setup lang="ts">
defineProps<{
  data: object
}>()
</script>
